// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__GMSz1","Title":"Header_Title__l0Aet"};